import { useCallback, useMemo, useRef, useState } from "react";
import { CAPTURE_MODES, DOCUMENT_SIDES } from "../../../config";

export const useDocumentIdPictureMedia = ({
  captureMode,
  documentSide,
  documentType,
}) => {
  const isUploadMode = captureMode === CAPTURE_MODES.UPLOAD;

  const captureRef = useRef(null);
  const [captureState, setCaptureState] = useState({
    hasPicture: false,
    videoReady: false,
    capturedBase64: undefined,
    previewUrl: undefined,
    cameraError: null,
  });

  const handleCaptureStateChange = useCallback((s) => {
    setCaptureState(s);
  }, []);

  const subtitle = useMemo(() => {
    const isNie = documentType === "nie_eu" || documentType === "nie_non_eu";
    if (documentSide === DOCUMENT_SIDES.FRONT)
      return isNie ? "DOCUMENT_ID_FRONT_NIE" : "DOCUMENT_ID_FRONT_DNI";
    if (documentSide === DOCUMENT_SIDES.BACK)
      return isNie ? "DOCUMENT_ID_BACK_NIE" : "DOCUMENT_ID_BACK_DNI";
    return isNie ? "DOCUMENT_ID_FRONT_NIE" : "DOCUMENT_ID_FRONT_DNI";
  }, [documentSide, documentType]);

  const selectedBase64 = captureState.capturedBase64;
  const hasSelectedPicture = captureState.hasPicture;

  const takePicture = useCallback(() => {
    captureRef.current?.takePicture?.();
  }, []);

  return {
    captureRef,
    captureState,
    handleCaptureStateChange,
    isUploadMode,
    selectedBase64,
    hasSelectedPicture,
    subtitle,
    takePicture,
  };
};
